//
//
//
//
//
//
//
//
//

export default {
  name: "NctcogSearchApp",
};
